import { useMemo } from 'react';
import { useLanguage } from '../../../../../context/LanguageContext';
import { useBrandConfig } from '../../../../../context/BrandConfigContext';
import DualListSelectionDialogEditor from '../ValueEditors/DualListSelectionDialogEditor';
import FieldLabel from './FieldLabel';
import {
    DUAL_LIST_NO_SEARCH_FIELD_NAMES,
    IDENTIFIER_LIST_FIELD_NAME,
    resolveFieldLabel,
} from './fieldConfig';
import { resolveFieldValues } from './fieldValues';
import { RowProps } from './rowProps';

function DualListRow({ field, rule, onUpdateField }: RowProps) {
    const { t } = useLanguage();
    const { ready: brandReady, setting } = useBrandConfig();
    const hideSearch = DUAL_LIST_NO_SEARCH_FIELD_NAMES.has(field.name);

    const values = useMemo(() => {
        const resolved = resolveFieldValues(field, t);
        if (field.name !== IDENTIFIER_LIST_FIELD_NAME) return resolved;
        // Types d'identifiants proposés par l'enseigne (query.identifiers.default.list) ; tous tant qu'elle n'est pas chargée
        const visibleIds = brandReady ? setting('query.identifiers.default.list') : [];
        return visibleIds.length ? resolved.filter(v => visibleIds.includes(v.name)) : resolved;
    }, [field, t, brandReady, setting]);

    const ruleValue = rule?.value;
    const includeValues = Array.isArray(ruleValue) ? ruleValue : [];

    return (
        <>
            <FieldLabel field={field} />
            <DualListSelectionDialogEditor
                includeValues={includeValues}
                excludeValues={rule?.notValue ?? []}
                values={values}
                title={resolveFieldLabel(field, t)}
                onChange={(data) => onUpdateField(field.name, { operator: 'in', ...data })}
                hideSearch={hideSearch}
                outerLabels={hideSearch ? {
                    include: t('pages.clients.queryBuilder.simple.dualSelectionDialog.belongsToTypes'),
                    exclude: t('pages.clients.queryBuilder.simple.dualSelectionDialog.doesNotBelongToTypes'),
                } : undefined}
                dialogMaxWidth={hideSearch ? 'sm' : 'md'}
            />
        </>
    );
}

export default DualListRow;
